import { bootstrapApplication } from '@angular/platform-browser';
import { LP_UI_CONFIG, VersionChecker } from '@lp-ui-lib';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

function getRuntimeConfig() {
  return environment;
}
const envValues: any = getRuntimeConfig();
appConfig.providers.push({ provide: LP_UI_CONFIG, useValue: envValues });
bootstrapApplication(App, appConfig)
  .then(() => {
    // Initialize version checker after app bootstrap
    VersionChecker.initialize(true);
  })
  .catch((err) => console.error(err));
